var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompaniesIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M102.665 55.9994C102.665 81.7781 81.7727 102.666 55.9987 102.666C30.2247 102.666 9.33203 81.7781 9.33203 55.9994C9.33203 30.2301 30.2247 9.33278 55.9987 9.33278C81.7727 9.33278 102.665 30.2301 102.665 55.9994Z",
    fill: "#136BFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.676 73.8004C72.0647 73.8004 71.4487 73.6417 70.884 73.3104L52.5627 62.381C51.508 61.7464 50.8594 60.603 50.8594 59.371V35.8184C50.8594 33.8864 52.4274 32.3184 54.3594 32.3184C56.2914 32.3184 57.8594 33.8864 57.8594 35.8184V57.383L74.4727 67.2904C76.1294 68.2844 76.6754 70.431 75.686 72.0924C75.028 73.189 73.866 73.8004 72.676 73.8004Z",
    fill: "#136BFE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompaniesIcon2);
export default __webpack_public_path__ + "static/media/companies-icon-2.54630937b8dd1cd0001cc7fe9ad2a5bf.svg";
export { ForwardRef as ReactComponent };